import React, { useState } from "react";
import { Twitter, Share2, Check } from "lucide-react";
import { shareX, shareReddit, copyShare } from "@/lib/share";

export function ShareButtons({ text, title, testid }) {
  const [copied, setCopied] = useState(false);
  const onCopy = () => { copyShare(text); setCopied(true); setTimeout(() => setCopied(false), 1500); };
  return (
    <div className="flex items-center gap-1.5" data-testid={testid}>
      <span className="text-[9px] tracking-widest text-[var(--text-3)] font-mono mr-0.5">SHARE</span>
      <button onClick={() => shareX(text)} className="text-[var(--text-3)] hover:text-[var(--accent)] transition-colors" title="Share on X" data-testid={`${testid}-x`}>
        <Twitter className="w-3.5 h-3.5" />
      </button>
      <button onClick={() => shareReddit(title || text)} className="text-[var(--text-3)] hover:text-[var(--accent)] transition-colors" title="Share on Reddit" data-testid={`${testid}-reddit`}>
        <Share2 className="w-3.5 h-3.5" />
      </button>
      <button onClick={onCopy} className="text-[var(--text-3)] hover:text-[var(--accent)] transition-colors" title="Copy" data-testid={`${testid}-copy`}>
        {copied ? <Check className="w-3.5 h-3.5 text-[var(--accent)]" /> : <span className="text-[10px] font-mono">⧉</span>}
      </button>
    </div>
  );
}
